<template>
  <swiper ref="swiper"
          :key="renderKey"
          class="swiper-container best-offers-slider"
          :modules="modules"
          :slides-per-view="slidesPerView"
          :slides-per-group="slidesPerGroup"
          :grid="{ rows: slidesPerColumn, fill: 'row' }"
          :space-between="12"
          :simulate-touch="false"
          @swiper="onSwiper"
          @init="onInit"
  >
    <swiper-slide v-for="(item, index) in items" :key="index">
      <slot :item="item" :index="index">{{ index }}</slot>
    </swiper-slide>
  </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {Grid} from "swiper/modules";
import "swiper/css";
import "swiper/css/grid";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    currentPage: Number,
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      renderKey: 0,
      slidesPerView: 3,
      slidesPerGroup: 3,
      modules: [Grid],
      swiperInstance: null,
    };
  },
  watch: {
    currentPage(value) {
      this.slideTo(value);
    },
    items() {
      this.renderKey += 1;
      this.$nextTick(() => this.slideTo(this.currentPage));
    },
  },
  computed: {
    slidesPerColumn() {
      return this.items.length > this.slidesPerView ? 2 : 1;
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiperInstance = swiper;
      this.slideTo(this.currentPage);
    },
    slideTo(currentPage) {
      if (!this.swiperInstance) {
        return;
      }
      const page = currentPage * this.slidesPerGroup;
      this.swiperInstance.slideTo(page, 0);
    },
    
    onInit(swiper) {
      const rows = swiper.params.grid?.rows || 1;
      const height = swiper.slides.slice(0, rows).reduce((acc, slideEl) => acc + slideEl.offsetHeight, swiper.params.spaceBetween);
      swiper.wrapperEl.style.height = `${height}px`;
      this.updateSwiperWrapperHeight();
    },

    //Костыль для масштаба 150. Для нормальной отрисовки не хватает 1px. 
    //https://mantis.pegasys.io/view.php?id=16745
    updateSwiperWrapperHeight() {
      const container = document.querySelector('.home-page__best-offers');
      const element = container.querySelector('.swiper-wrapper');
      const elementValues = element.getBoundingClientRect();
      element.style.height = (elementValues.height + 1) + 'px';
    }
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  --card-height: 313px;
  --pad: 12px;
  --gap: 12px;
  --promo-shadow-hover: 0 5px 8px 0 rgba(168,168,168,.25);
  padding: var(--pad);
  margin: calc(-1 * var(--pad));
  box-sizing: content-box;

  :deep(.swiper-wrapper) {
    height: calc(var(--card-height) * 2 + var(--gap));
  }
  
  :deep(.swiper-slide) {
    border-radius: var(--border-radius-lg);
    overflow: hidden;
    box-shadow: var(--shadow);
    height: var(--card-height);
    
    &:hover {
      box-shadow: var(--promo-shadow-hover);
    }
  }
}
</style>


